import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logoWordless from '../../assets/logo/logoWordless.svg';
import ArrowRight from '../../assets/icons/chevron_right_icon_orange.svg';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Container = styled.div`
    display: flex;
    height: 70rem;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat',sans-serif !important;
`;

export const Box = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;

    p {
        margin-bottom: 0;
    }

    ${MediaQuery.medium`
        flex-direction: row;
        gap: 48px;
    `}
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    padding: 20px;

    ${MediaQuery.medium`
        align-items: flex-start;
        padding: 0;
    `}
`;

export const TextBox = styled.div`
    display: flex;
    flex-direction: column;

    h1, h3, p {
        text-align: center;
    }

    h1 {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 2.4rem;
        line-height: 3.12rem;
        margin-bottom: 12px;
    }

    h3 {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 2.0rem;
        line-height: 3.0rem;
        margin-bottom: 0;
    }

    ${MediaQuery.medium`
        h1, h3, p {
            text-align: left;
        }

        h1 {
            font-size: 2.8rem;
            line-height: 3.64rem;
            margin-bottom: 4px;
        }
    `}
`;

export const Logo = styled.img.attrs(() => ({ src: logoWordless }))`
    width: 20rem;
`;

export const Arrow = styled.img.attrs(() => ({ src: ArrowRight }))`
    height: 75%;
`;

export const Navigate = styled(Link)`
    font-size: 1.6rem;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    text-decoration: none;
    gap: 5px;

    &:hover,
    &:active,
    &:visited {
        text-decoration: underline;
        text-underline-offset: 2px;
        text-decoration-color: ${colors.BRAND_ORANGE};
        color: ${colors.BLACK};
    }
`;
